import { contentItemLabel, courierNames, dayLabel, shipmentTitle } from "pages/EventsManagement/components/Tabs/Logistics/shipmentLabels"
import { sheetStatuses } from "pages/EventsManagement/components/Tabs/Logistics/labels"
import { shipmentShipped } from "pages/EventsManagement/components/Tabs/Logistics/sheetState"
import { filterParams } from "../addressFilters"

// ——— How the Shipments page writes its rows and filters; a shipment's own words are the Logistics tab's (shipmentLabels.js) ———

// The filters the page keeps in its address, as the API reads them (US 135, ticket 22 Q5).
export const FILTERS = ["from", "to", "clubId", "transport", "show"]

// The filter the page shows, with the period the API chose, as the export's parameters; showing every shipment is no filter.
export const exportParams = filter => filterParams(filter, FILTERS, { show: "all" })

// How a shipment may have left, and what the page may show.
export const transports = [...Object.entries(courierNames).map(([value, label]) => ({ value, label })), { value: "noCourier", label: "Without courier" }]
export const shown = [{ value: "alerts", label: "Courier alerts" }, { value: "returns", label: "With a return" }]

// "Main shipment · 20 Nov 2026", "Supplementary #2 · In preparation", "Main shipment · Ready for processing": the shipment, and the day it
// left or the state it is in (`stage`, the main shipment's its sheet's).
export const shipmentLabel = shipment => `${shipmentTitle(shipment)} · ${shipmentShipped(shipment.status) ? dayLabel(shipment.date)
  : sheetStatuses[shipment.stage]?.label || shipment.stage}`
// "Balls Wilson Tour Premier (can of 4) 1 can · 1 Dec 2026": what came back, net of its corrections, and the day of the last return.
export const returnedLabel = ({ returned, returnedOn }) => `${returned.map(contentItemLabel).join(", ")} · ${dayLabel(returnedOn)}`
